import React, { useEffect } from 'react';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

import { Card, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import HtmlHead from 'components/html-head/HtmlHead';
import Loading from 'components/loading/Loading';

import ExcelExport from 'components/export/ExcelExport';
import { getColonne, richiediDati } from './funzioni';

const { SearchBar } = Search;

const Tabella = ({ data, history }) => {
  return (
    <ToolkitProvider keyField="ID" data={data} columns={getColonne(history)} search>
      {(props) => (
        <div>
          <SearchBar {...props.searchProps} />
          <hr />
          <BootstrapTable
            id="tabella-contratti"
            striped
            bootstrap4
            condensed
            wrapperClasses="table-responsive"
            {...props.baseProps}
            pagination={paginationFactory({
              sizePerPage: 10,
            })}
          />
        </div>
      )}
    </ToolkitProvider>
  );
};

const Contratti80 = ({ history }) => {
  useEffect(() => {
    richiediDati();
  }, []);

  const { caricamentoInCorso, contratti } = useSelector((state) => state.contratti80);

  if (caricamentoInCorso) {
    return (
      <>
        <HtmlHead title="Caricamento" />
        <Loading />
      </>
    );
  }

  return (
    <>
      <HtmlHead title="Contratti" />
      <Row>
        <Col>
          <section className="scroll-section mb-3" id="title">
            <h1 className="mb-0 pb-0 display-4">Contracts</h1>
          </section>

          <section className="scroll-section" id="table">
            <Card>
              <Card.Body>
                <Tabella data={contratti} history={history} />
                <Card.Header className="d-flex justify-content-between w-100">
                  <Card.Title>Deadlines </Card.Title>
                  <ExcelExport idTabella="tabella-contratti" />
                </Card.Header>
              </Card.Body>
            </Card>
          </section>
        </Col>
      </Row>
    </>
  );
};

export default React.memo(Contratti80);
